// @flow

import React, { useEffect, useState } from 'react'
import { Snackbar, Typography } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'
import { makeStyles } from '@material-ui/core/styles'
import type { Element } from 'react'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiAlert-icon': {
      fontSize: 20,
    },
    '& .MuiAlert-message': {
      fontSize: 14,
      padding: '12px 0',
    },
  },
}))

type Props = {
  message: string,
  setMessage: (string) => void,
}

function AlertSuccess({ message, setMessage }: Props): Element<typeof React.Fragment> {
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (message) {
      setIsOpen(true)
    }
  }, [message])

  const Alert = (props): Element<typeof MuiAlert> => {
    return <MuiAlert elevation={0} variant="filled" {...props} />
  }

  const handleClose = (event, reason): void => {
    setIsOpen(false)
    setMessage('')
  }

  return (
    <Snackbar
      open={isOpen}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Alert className={classes.root} onClose={handleClose} severity="success">
        <Typography color="inherit">{message}</Typography>
      </Alert>
    </Snackbar>
  )
}

export default AlertSuccess
